module.exports = __webpack_public_path__ + "static/img/ml-logo.4f9a504a.png";